import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../Services/api.service';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { AuthService } from '../Services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NzIconModule, CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  zoomLevel: any = 100;
  username: any = '';
  password: any = '';
  loginError: boolean = false;
  viewPassword: boolean = false;
  currentYear: any;
  private subscription!: Subscription;
  notifyRef: any;
  emptyCreds: boolean = false;

  constructor(public apiService: ApiService, public authService: AuthService,
    private router: Router, public notificationService: NzNotificationService
  ) { }

  @HostListener('window:load', ['$event'])
  onLoad(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.subscription = this.authService.userLogoutMessage$.subscribe({
      next: (data: any) => {
        if (data && data.message !== '') {
          if (this.notifyRef) {
            this.notificationService.remove();
          }
          let notificationType = (data.type == 'type3' || data.type == 'type4') ? 'error' : 'success';
          this.notifyRef = this.apiService.createNotification(notificationType, data.message, { nzDuration: 0 });
        }
      },
      error: (err) => console.error('Error in subscription:', err)
    });
  }

  async login() {
    if (!this.username || !this.password) {
      this.emptyCreds = true;
      return
    }
    this.emptyCreds = false;

    try {
      await this.apiService.login(this.username, this.password).subscribe(res => {
        if (this.notifyRef) {
          this.notificationService.remove();
        }
        this.authService.initLoggedInUser(res);
        this.router.navigate(['/dashboard']);
      }, err => {
        if (this.notifyRef)
          this.notificationService.remove();
        if (err.status == 404) {
          this.authService.logout('type4', false);
        } else {
          this.authService.logout('type3', false);
        }
      });
    }
    catch (error) {
      if (this.notifyRef)
        this.notificationService.remove();
      this.authService.logout('type3');
    }
  }

  togglePassword() {
    this.viewPassword = !this.viewPassword;
  }

  ngOnDestroy(): void {
    // Prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
